import { useState } from "react"

export function NewTodoForm({onSubmit}){
    const [newItem,setNewItem] = useState("")
    
    function handleSubmit(e) {
        e.preventDefault()
      
        /*
        setTodos((currentTodos) => {
          return [
            ...currentTodos,
            {id: crypto.randomUUID(), title: newItem, compeleted: false},
          ]
      })
      */
        if (newItem === "") return
            //addTodo(newItem)
            //props.onSubmit(newItem)

            onSubmit(newItem)
        
        setNewItem("")
      }

    return (
      <>
      
    <form onSubmit={handleSubmit} className="new-item-form">
<       div className="form-row">
            <label htmlFor="item" className="header-text">Add new item</label>
            <input value={newItem} 
            onChange = {e => setNewItem(e.target.value)}
            type="text" 
            id="item" />
        </div>
        <button className="btn add-button">Add</button>
        </form>
        
        </>
    )
}